import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export default class DetailCard extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'back-href': `string`,
      'back-href-text': `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleBackClick: (event) => {
          event.preventDefault();
          const modifierKey = event.ctrlKey || event.metaKey;
          this.dispatchEvent(
            new CustomEvent(`goBack`, {
              detail: {modifierKey},
              bubbles: true,
            }),
          );
        },
      },
    };
  }

  get backHref() {
    return this.attr(`back-href`);
  }

  get backHrefText() {
    return this.attr(`back-href-text`);
  }
}

registerMPElement(`mp-detail-card`, DetailCard);
